/* global cURL */
export class Accessibility {
  #htmlElement;

  constructor() {
    this.#htmlElement = document.documentElement;
    this.#bindEvents();
  }

  /**
   * Toggle font size.
   */
  #handleFontSizeToggle = async e => {
    e.preventDefault();
    const url = new URL(`${cURL}mwork/ajax/change-accessibility-property.jsp`);
    const params = {
      type: 'font-size'
    };
    Object.entries(params).forEach(([k, v]) => url.searchParams.append(k, v));
    try {
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
      const data = await response.json();
      const newFontSize = parseInt(data, 10);
      if (isNaN(newFontSize))
        throw new Error('Received data is not a valid number for font size.');
      if (newFontSize < 1 || newFontSize > 3)
        throw new Error(`Received font size (${newFontSize}) is out of expected range.`);
      this.#htmlElement.classList.remove('font-size--1', 'font-size--2', 'font-size--3');
      this.#htmlElement.classList.add(`font-size--${newFontSize}`);
    }
    catch (error) {
      console.error('Failed to change accessibility property (font size)', error);
    }
  };

  /**
   * Toggle high contrast.
   */
  #handleHighContrastToggle = async e => {
    e.preventDefault();
    const url = new URL(`${cURL}mwork/ajax/change-accessibility-property.jsp`);
    const params = {
      type: 'high-contrast'
    };
    Object.entries(params).forEach(([k, v]) => url.searchParams.append(k, v));
    try {
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
      const data = await response.json();
      const newHighContrast = parseInt(data, 10);
      if (isNaN(newHighContrast))
        throw new Error('Received data is not a valid number for high contrast.');

      if (!!newHighContrast) this.#htmlElement.classList.add('high-contrast');
      else this.#htmlElement.classList.remove('high-contrast');
    }
    catch (error) {
      console.error('Failed to change accessibility property (high contrast)', error);
    }
  };

  #bindEvents() {
    document.querySelectorAll('[data-font-size]').forEach(el => {
      el.addEventListener('click', this.#handleFontSizeToggle);
    });
    document.querySelectorAll('[data-high-contrast]').forEach(el => {
      el.addEventListener('click', this.#handleHighContrastToggle);
    });
  }
}
